export const getCurrentPlatform = (): string => {
  let platform = window.innerWidth <= 650 ? 'Web Mobile' : 'Web';

  if (!!window.RahmetApp) {
    platform = 'Superapp';
  }

  return platform;
};
